export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';

export const AUTOPARK_FORM_NAME = 'autopark-form';

export const REQUIRED_FIELDS = ['tk_id'];

export const FIELDS_FOR_VALIDATE = ['tk_id', 'name'];
